import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'simulated.modals.approve.title',
    defaultMessage: 'Approve all',
  },
  subtitle: {
    id: 'simulated.modals.approve.subtitle',
    defaultMessage: 'Are you sure you want to approve all skills?',
  },
  close: {
    id: 'simulated.modals.approve.close',
    defaultMessage: 'Close',
  },
  cancel: {
    id: 'simulated.modals.approve.cancel',
    defaultMessage: 'Cancel',
  },
  continue: {
    id: 'simulated.modals.approve.continue',
    defaultMessage: 'Continue',
  },
  success: {
    id: 'simulated.modals.approve.success',
    defaultMessage: 'Approval successful!',
  },
  problem: {
    id: 'simulated.modals.approve.problem',
    defaultMessage: 'Skills failed to pass',
  },
});
